import { createButton } from 'react-simple-wysiwyg';

import { Bold01Icon } from '@/assets/icons/Bold01Icon';

export default createButton('Bold', <Bold01Icon />, 'bold');
